"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BurnerProvider_1 = require("./BurnerProvider");

exports.DEFAULT_PLUGIN_DATA = {
  pages: [],
  homeButtons: [],
  elements: {},
  accountSearches: [],
  tryHandleQR: function tryHandleQR() {
    return false;
  },
  sent: function sent() {
    return null;
  }
};

var Plugins =
/** @class */
function () {
  function Plugins(plugins, ui) {
    var _this = this;

    this.changeListeners = [];
    this.sentHandlers = [];
    this.qrHandlers = [];
    this.ui = ui;
    this.pluginData = __assign({}, exports.DEFAULT_PLUGIN_DATA, {
      tryHandleQR: this.tryHandleQR.bind(this),
      sent: this.sent.bind(this)
    });
    plugins.forEach(function (plugin) {
      return plugin.initializePlugin(_this.getPluginContext(plugin));
    });
  }

  Plugins.prototype.onDataChange = function (listener) {
    this.changeListeners.push(listener);
  };

  Plugins.prototype.getData = function () {
    return this.pluginData;
  };

  Plugins.prototype.getPluginContext = function (plugin) {
    var _this = this;

    return {
      addElement: function addElement(position, Component) {
        return _this.addPluginElement(plugin, position, Component);
      },
      onAccountSearch: function onAccountSearch(callback) {
        return _this.addAccountSearch(callback);
      },
      onQRScanned: function onQRScanned(callback) {
        return _this.qrHandlers.push(callback);
      },
      onSent: function onSent(callback) {
        return _this.sentHandlers.push(callback);
      },
      addPage: function addPage(path, Component) {
        return _this.addPluginPage(plugin, path, Component);
      },
      addHomeButton: function addHomeButton(title, path) {
        return _this.addPluginHomeButton(plugin, title, path);
      },
      getAssets: function getAssets() {
        return _this.ui.getAssets();
      },
      getWeb3: function getWeb3(network, options) {
        return _this.ui.getCore().getWeb3(network, options);
      }
    };
  };

  Plugins.prototype.setPluginData = function (newData) {
    var _this = this;

    this.pluginData = __assign({}, this.pluginData, newData);
    this.changeListeners.forEach(function (listener) {
      return listener(_this.pluginData);
    });
  };

  Plugins.prototype.addPluginPage = function (plugin, path, Component) {
    var WrappedComponent = BurnerProvider_1.withBurner(Component);
    this.setPluginData({
      pages: this.pluginData.pages.concat([{
        plugin: plugin,
        path: path,
        Component: WrappedComponent
      }])
    });
  };

  Plugins.prototype.addPluginHomeButton = function (plugin, title, path) {
    this.setPluginData({
      homeButtons: this.pluginData.homeButtons.concat([{
        plugin: plugin,
        title: title,
        path: path
      }])
    });
  };

  Plugins.prototype.addPluginElement = function (plugin, position, Component) {
    var _a;

    var WrappedComponent = BurnerProvider_1.withBurner(Component);
    var existingElements = this.pluginData.elements[position] || [];
    this.setPluginData({
      elements: __assign({}, this.pluginData.elements, (_a = {}, _a[position] = existingElements.concat([{
        plugin: plugin,
        Component: WrappedComponent
      }]), _a))
    });
  };

  Plugins.prototype.addAccountSearch = function (callback) {
    this.setPluginData({
      accountSearches: this.pluginData.accountSearches.concat([callback])
    });
  };

  Plugins.prototype.tryHandleQR = function (qr, context) {
    for (var _i = 0, _a = this.qrHandlers; _i < _a.length; _i++) {
      var handler = _a[_i];

      if (handler(qr, context)) {
        return true;
      }
    }

    return false;
  };

  Plugins.prototype.sent = function (data) {
    var redirect = null;

    for (var _i = 0, _a = this.sentHandlers; _i < _a.length; _i++) {
      var listener = _a[_i];
      var response = listener(data);

      if (!redirect && response && response.length) {
        redirect = response;
      }
    }

    return redirect;
  };

  return Plugins;
}();

exports.default = Plugins;